import { goldenRules } from 'constants/goldenRules/goldenRules';
import styles from './drawer.module.css'
import { Checkbox, Divider } from 'antd';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import { Paper } from '@mui/material';
import { DrawerSchema } from 'schemas';
import { useRecoilState, useRecoilValue } from 'recoil';
import LinearProgressComponent from 'components/linearProgress/linearProgress';
import CustomTooltip from 'components/toolTip/tooltip';
import { userData } from 'schemas';
import { safeJsonParse } from 'utils/common/safeJsonParse';
import { useDrawerPermissions } from './hooks/useDrawerPermissions';

export default function RulesAssigner({ setEnableUpdate, loading }) {
    const [open, setOpen] = useRecoilState(DrawerSchema)
    const user = useRecoilValue(userData)
    const { canAssignRules } = useDrawerPermissions(open, user)

    const savedRules = safeJsonParse(open?.data?.regrasDeOuro, [])

    function haveSameElements(arr1, arr2) {
        if (arr1.length !== arr2.length) return false;
        return [...arr1].sort().toString() === [...arr2].sort().toString();
    }

    function showBtn(rules, parsedRules) {
        if (typeof setEnableUpdate === 'function' && !haveSameElements(rules, parsedRules))
            setEnableUpdate(true)
        else if (typeof setEnableUpdate === 'function' && haveSameElements(rules, parsedRules))
            setEnableUpdate(false)
    }

    const onChange = (value, id) => {
        const copy = { ...open }
        const parsedRules = savedRules

        if (value) {
            const currentRules = copy.rulesInitialized ? copy.pendingRules : parsedRules
            const rules = [...new Set([...currentRules, id])]
            setOpen({ ...copy, pendingRules: rules, rulesInitialized: true })

            showBtn(rules, parsedRules)
        } else {
            const currentRules = copy.rulesInitialized ? copy.pendingRules : parsedRules
            const rules = currentRules.filter(ruleId => ruleId !== id)
            setOpen({ ...copy, pendingRules: rules, rulesInitialized: true })

            showBtn(rules, parsedRules)
        }
    }

    const checkIfChecked = (id) => {
        const rules = open?.rulesInitialized ? open.pendingRules : savedRules
        return rules.includes(id)
    }

    return (
        <div style={{ padding: "0 20px" }} >
            <MDBox
                mx={2}
                mt={-3}
                py={0}
                px={0}
                variant="gradient"
                bgColor="success"
                borderRadius="lg"
                coloredShadow="dark"
                style={{ background: "#58A4B0", margin: "-10px 0 0 -10px" }}
            >
                {loading && <LinearProgressComponent />}
                <div style={{ padding: "15px 10px" }} >
                    <MDTypography variant="h6" color="white" >
                        Lista das regras de ouro
                    </MDTypography>
                </div>
            </MDBox>
            <Paper style={{ overflow: "auto", height: "80.5vh", marginTop: "10px", paddingTop: "20px" }} >
                {
                    goldenRules().map((x, index) => {
                        return (
                            <div key={x.sectionName} className={styles.rules} >
                                <div className={styles.pic} >
                                    <CustomTooltip
                                        child={<img style={{ height: "55px", width: "60px" }} src={x.picture} />}
                                        title={x.sectionName}
                                    />
                                </div>
                                <div style={{ width: "90%" }} >
                                    {
                                        x.rules.map((rule) => {
                                            return (
                                                <ul key={rule.id} className={styles.ul} >
                                                    <h1 className={styles.rule} >{rule.label}</h1>
                                                    <Checkbox disabled={!canAssignRules} checked={checkIfChecked(rule.id)} onChange={(e) => { onChange(e.target.checked, rule.id) }} aria-label={`Atribuir regra ${rule.label}`} />
                                                </ul>
                                            )
                                        })
                                    }
                                    {index !== goldenRules().length - 1 && < Divider />}
                                </div>
                            </div>
                        )
                    })
                }
            </Paper>
        </div>
    )
}
